import { Component } from 'react';
import { Accordion } from 'react-bootstrap';
import { css } from '@emotion/react';

import HeuristicResponseTemplate from './HeuristicResponseTemplate';

import redWarning from '../../../assets/red-check-mark.png';
import yellowWarning from '../../../assets/yellow-warning.png';
import greenCheckMark from '../../../assets/green-check-mark.png';

import { STATUS_ERROR, STATUS_WARNING } from '../../../constants/seoStatus';
import { HeuristicsResponseType } from '../../../utils/heuristics/Heuristics';
import { BackgroundColorEnum } from '../../../constants/cms-constants';

const useStyles = css({
  '.accordion-indicator': {
    marginLeft: 'auto',
    display: 'flex',
    alignItems: 'center',
    img: {
      height: '25px',
      width: '25px',
    },
  },
  '.empty': {
    textAlign: 'center',
    paddingTop: '2em',
    color: BackgroundColorEnum.GRAY,
  },
  '& .accordion-button::after': {
    display: 'none',
  },
  '& .accordion-button:focus': {
    boxShadow: 'none',
  },
  '& .accordion-button': {
    backgroundColor: BackgroundColorEnum.LIGHTGRAY,
    userSelect: 'none',
    borderBottom: `0.5px solid ${BackgroundColorEnum.BRIGHTGRAY}`,
    paddingTop: '12px',
    paddingBottom: '12px',
    marginBottom: '-1px',
  },
  '& .accordion-body': {
    paddingTop: '20px',
    paddingBottom: '20px',
  },
});

function getStatusIcon(status) {
  if (status === STATUS_ERROR) {
    return redWarning;
  }
  if (status === STATUS_WARNING) {
    return yellowWarning;
  }
  return greenCheckMark;
}

function renderResponse(heuristicResponse) {
  // Responses from heuristics can be rendered by template or bespoke display.
  return (
    heuristicResponse.display ?? (
      <HeuristicResponseTemplate
        title={heuristicResponse.title}
        errorMessage={heuristicResponse.error}
        path={heuristicResponse.path}
        description={heuristicResponse.generalText}
      />
    )
  );
}

type SeoAccordionProps = {
  heuristicResponses?: HeuristicsResponseType[];
};

class SeoAccordion extends Component<SeoAccordionProps> {
  static defaultProps = {
    heuristicResponses: [],
  };

  render() {
    const { heuristicResponses } = this.props;
    const isEmpty = !heuristicResponses || heuristicResponses.length === 0;
    return (
      <div css={useStyles}>
        <Accordion>
          {heuristicResponses.map((response, idx) => {
            const eventKey = `${response.name}-${idx}`;
            return (
              <Accordion.Item key={eventKey} eventKey={eventKey}>
                <Accordion.Header>
                  {response.name}
                  <div className="accordion-indicator">
                    <img
                      src={getStatusIcon(response.status)}
                      alt="Icon indicating level of issue for a seo reader"
                    />
                  </div>
                </Accordion.Header>
                <Accordion.Body>{renderResponse(response)}</Accordion.Body>
              </Accordion.Item>
            );
          })}
        </Accordion>
        {isEmpty ? <p className="empty">Empty</p> : null}
      </div>
    );
  }
}

export default SeoAccordion;
